<template>
  <div
    class="d-flex flex-column justify-content-between mt-4"
    id="nav-container"
  >
    <div id="top-nav">
      <ul class="nav flex-column" v-if="user.role === 'space_owner'">
        <li class="nav-item">
          <router-link
            class="d-flex align-items-center nav-link py-3"
            :to="{ name: 'BookingsPage' }"
          >
            <img
              src="@/assets/images/icons/sidebar-icons/booking.svg"
              alt="booking-icon"
            />
            <span>{{ $t("sidebar.menu.bookings") }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="d-flex align-items-center nav-link py-3"
            :to="{ name: 'SeatsPage' }"
          >
            <img
              src="@/assets/images/icons/sidebar-icons/seats.svg"
              alt="seats-icon"
            />
            <span class="ms-1">{{ $t("sidebar.menu.seats") }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="d-flex align-items-center nav-link py-3"
            :to="{ name: 'InfoPage', params: { id: spaceId } }"
          >
            <img
              src="@/assets/images/icons/sidebar-icons/coworking.svg"
              alt="coworking-icon"
            />
            <span>{{ $t("sidebar.menu.coworking-info") }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <a
            class="d-flex align-items-center nav-link py-3"
            href="/static/contract.pdf"
            download="contract.pdf"
          >
            <img
              src="@/assets/images/icons/sidebar-icons/contract.svg"
              alt="contract-icon"
            />
            <span>{{ $t("sidebar.menu.contract") }}</span>
          </a>
        </li>
      </ul>

      <SuperAdminMenu v-if="user.role === 'superadmin'" />
    </div>
    <div id="bottom-nav">
      <div class="mt-4">
        <ul class="nav flex-column">
          <li class="mt-1 nav-item">
            <a
              class="d-flex align-items-center nav-link py-3"
              href="/static/guide.pdf"
              download="guide.pdf"
            >
              <img
                src="@/assets/images/icons/sidebar-icons/user-guide.svg"
                alt="userGuide-icon"
              />
              <span>{{ $t("sidebar.menu.user-guide") }}</span>
            </a>
          </li>
          <li class="mt-1 nav-item">
            <router-link
              class="d-flex align-items-center nav-link py-3"
              :to="{ name: 'SettingsPage' }"
            >
              <img
                src="@/assets/images/icons/sidebar-icons/settings.svg"
                alt="settings-icon"
              />
              <span>{{ $t("sidebar.menu.settings") }}</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="user.role === 'space_owner'">
            <router-link
              class="d-flex align-items-center nav-link py-3"
              :to="{ name: 'AccountingPage' }"
            >
              <img
                src="@/assets/images/icons/sidebar-icons/accounting.svg"
                alt="accounting-icon"
              />
              <span class="ms-1">{{ $t("sidebar.menu.accounting") }}</span>
            </router-link>
          </li>
          <li class="nav-item cursor-pointer" @click="logout">
            <a class="d-flex align-items-center nav-link py-3">
              <img
                src="@/assets/images/icons/sidebar-icons/accounting.svg"
                alt="logout-icon"
              />
              <span class="ms-1">{{ $t("sidebar.menu.log-out") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div
        id="footer-nav"
        class="text-center"
        v-if="action && user.role === 'space_owner'"
      >
        <div v-if="action === 'published'">
          <p class="mt-4">
            {{ $t("sidebar.actions.status-published") }}
            {{ $t("sidebar.actions.since") }} {{ $moment(space.createdAt).format("DD-MM-Y") }}
          </p>
        </div>
        <div id="publish" v-if="action === 'publish'">
          <p class="mt-4">
            {{ $t("sidebar.actions.status-label") }} {{ $t("sidebar.actions.status-not-published") }}
          </p>
          <!-- <LoadingButton
            :text="'Publish'"
            :classes="['btn-primary']"
            :loading="loading"
            :disabled="!spaceId || !space.products.length || !space.stripe || !space.stripe.onboarding.completed"
            @click="publishSpace()"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SpaceService from "@/services/space";
import SuperAdminMenu from "@/components/sidebar/components/SuperAdminMenu";

export default {
  components: {
    SuperAdminMenu
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters("sidebar", ["action"]),
    ...mapGetters("currentUser", ["user"]),
    ...mapGetters("currentUser", ["spaceId"]),
    ...mapGetters("space", ["space"])
  },
  methods: {
    async publishSpace() {
      this.loading = true;

      try {
        await SpaceService.changeSpaceStatus(this.spaceId, "to_approve");

        location.reload();
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    logout() {
      this.$store.dispatch("currentUser/logout");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/style";

#nav-container {
  height: 80vh;

  span {
    font-family: $mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #a4a6b3;
    padding-left: 20px;
  }

  #bottom-nav {
    border-top: 1px solid #dfe0eb;
  }

  .active {
    border-left: 3px solid #dde2ff;
    background-color: rgba(159, 162, 180, 0.08);

    span {
      color: #fff;
    }

    img {
      filter: brightness(0) invert(1);
    }
  }

  .nav-link:hover {
    background-color: rgba(159, 162, 180, 0.08);

    span {
      color: #fff;
    }

    img {
      filter: brightness(0) invert(1);
    }
  }

  #footer-nav {
    p {
      font-family: $inter;
      font-style: normal;
      font-weight: normal;
      font-size: 11.5745px;
      line-height: 14px;
      color: #ffffff;
    }

    #publish {
      button {
        width: 120px;
        height: 28px;
        font-family: $inter;
        font-style: normal;
        font-weight: normal;
        font-size: 11.574px;
        line-height: 14px;
        color: #ffffff;
        margin-bottom: 5px;
      }
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/components/SidebarActions.vue